// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".breadcrumbs[data-v-82ca9620]{display:flex}.breadcrumbs__item[data-v-82ca9620]{display:flex;align-items:center;color:#161b25;font-size:13px;line-height:16px;cursor:default}.breadcrumbs__arrow[data-v-82ca9620]{margin:0 6px;width:8px;height:8px;display:block}", ""]);
// Exports
module.exports = exports;
